import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { usePlan } from "@/lib/use-plan";

const SESSION_KEY = "wi:trial_banner_dismissed";

export default function TrialBanner() {
  const { isTrial, trialDaysLeft } = usePlan();
  const [dismissed, setDismissed] = useState(() =>
    typeof window !== "undefined" && sessionStorage.getItem(SESSION_KEY) === "1"
  );

  if (!isTrial || trialDaysLeft === null || trialDaysLeft > 7 || dismissed) return null;

  const urgent = trialDaysLeft <= 3;
  const lastDay = trialDaysLeft === 0;

  const tone = lastDay
    ? "bg-oxblood text-ivory border-b border-oxblood-deep"
    : urgent
    ? "bg-oxblood/10 border-b border-oxblood/30 text-foreground"
    : "bg-bone border-b border-border text-foreground";

  const headline = lastDay
    ? "Your trial ends today."
    : urgent
    ? `Trial ending in ${trialDaysLeft} day${trialDaysLeft === 1 ? "" : "s"}.`
    : `Your 14-day trial ends in ${trialDaysLeft} days.`;
  const sub = lastDay
    ? "Upgrade now to keep access to your wardrobe."
    : urgent
    ? "Upgrade now to avoid losing access."
    : "Pick a plan to keep your wardrobe intact.";

  function dismiss() {
    sessionStorage.setItem(SESSION_KEY, "1");
    setDismissed(true);
  }

  return (
    <div data-testid="trial-banner"
      className={`px-6 md:px-10 py-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm ${tone}`}>
      <span className="font-medium">{headline}</span>
      <span className={lastDay ? "text-ivory/85" : "text-muted-foreground"}>{sub}</span>
      <Link to="/app/settings/billing"
        data-testid="trial-banner-cta"
        className={`ml-auto sm:ml-3 underline underline-offset-4 font-medium ${
          lastDay ? "text-ivory hover:text-bone" : "text-oxblood hover:text-oxblood-deep"
        }`}>
        {lastDay ? "Upgrade now" : "Choose plan"}
      </Link>
      {!lastDay && (
        <button type="button" onClick={dismiss}
          data-testid="trial-banner-dismiss"
          aria-label="Dismiss for this session"
          className="text-muted-foreground hover:text-foreground ml-2">
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
